module.exports = __webpack_public_path__ + "img/swiper_5.e81a1a9a.jpg";